"use client";

import React from 'react';
import { useTypingEffect } from '@/hooks/useTypingEffect';

interface TypingTextProps {
    texts: string[];
    className?: string;
    typingSpeed?: number;
    fadeSpeed?: number;
    pauseTime?: number;
}

const TypingText: React.FC<TypingTextProps> = ({
    texts,
    className = '',
    typingSpeed = 5,
    fadeSpeed = 100,
    pauseTime = 500
}) => {
    const { currentText, opacity } = useTypingEffect({
        texts,
        typingSpeed,
        fadeSpeed,
        pauseTime
    });

    // Tính toán min-height dựa trên text dài nhất
    const maxLines = Math.max(...texts.map(text => text.split('\n').length));
    const minHeight = maxLines * 1.5; // 1.5em per line

    return (
        <span 
            className={className}
            style={{ 
                opacity,
                transition: `opacity ${fadeSpeed}ms cubic-bezier(0.4, 0, 0.2, 1)`,
                minHeight: `${minHeight}em`,
                display: 'inline-block',
                verticalAlign: 'top'
            }}
        >
            <span dangerouslySetInnerHTML={{ __html: currentText }} />
            <span className="animate-pulse">|</span>
        </span>
    );
};

export default TypingText; 